import { Box, Typography } from "@mui/material";

interface Props {
	plotted: number;
	total: number;
	products: number;
}

// The legacy screen drops every point that falls outside its fixed axes and says
// nothing about it — around a quarter of the rows on a long range. Naming the two
// counts costs a line and stops the chart from reading as the whole picture.
//
// What each axis measures is explained on the axis name itself, in the chart.
export const TimerSpeedReportSummary = ({
	plotted,
	total,
	products,
}: Props) => {
	const hidden = total - plotted;

	return (
		<Box sx={{ px: 0.5 }}>
			<Typography variant="caption" color="text.secondary">
				{`${plotted.toLocaleString()} of ${total.toLocaleString()} points in range`}
				{hidden > 0
					? ` — ${hidden.toLocaleString()} outside the axes or without speed`
					: ""}
				{` · ${products.toLocaleString()} products`}
			</Typography>
		</Box>
	);
};
